import triggerPopup from "../components/_trigger-popup";
import "bootstrap/js/dist/carousel";

// TRIGGER POPUP ON LOAD
triggerPopup("#cta-index");

// ALTERNATING MODALS
// $(document).ready(function () {
//   var classes = ["d-none", "d-block"];
//   var randomnumber = Math.floor(Math.random() * classes.length);

//   $(".variable-modal").addClass(classes[randomnumber]);
// });

// $(function () {
//   $(".demo-avd__close").click(function () {
//     $(".demo-avd").addClass("d-none");
//     $(".notification-wrapper").addClass("d-none");
//   });
// });
